import moment from 'moment'
import { ITEM_STATUS_CANCELLED } from 'constants/cart'

const EXPEDIA_SUPPLIER = 'expedia'
const EXPEDIA_SUPPLIER_CODE = 'S1'
const AGODA_SUPPLIER = 'agoda'
const AGODA_SUPPLIER_CODE = 'S14'
const NON_SPECIAL_REQUEST_VALUE = 'N/A'

export function isExpediaBedbankItem(item: App.OrderBedbankItem) {
  if (item.supplier === EXPEDIA_SUPPLIER) {
    return true
  }

  return item.offer.packages?.some(pkg => pkg.rate?.supplierCode === EXPEDIA_SUPPLIER_CODE) ?? false
}

export function isAgodaBedbankItem(item: App.OrderBedbankItem) {
  if (item.supplier === AGODA_SUPPLIER) {
    return true
  }

  if (item.supplier === EXPEDIA_SUPPLIER) {
    return false
  }

  return item.offer.packages?.some(pkg => pkg.rate?.supplierCode === AGODA_SUPPLIER_CODE) ?? false
}

export function hasBedbankGuestSpecialRequests(room: App.OrderBedbankRoom) {
  return Boolean(room.guestSpecialRequests && room.guestSpecialRequests !== NON_SPECIAL_REQUEST_VALUE)
}

export function isActiveBedbankGuestNameChangeBooking(
  item: App.OrderBedbankItem,
  room: App.OrderBedbankRoom,
) {
  return item.status !== ITEM_STATUS_CANCELLED &&
    room.status !== 'cancelled' &&
    room.status !== 'pending'
}

export function canChangeBedbankGuestName(params: {
  isSelfServiceNameChangeEnabled: boolean
  canEdit: boolean
  item: App.OrderBedbankItem
  room: App.OrderBedbankRoom
  canChangeGuestName?: boolean
}) {
  return params.isSelfServiceNameChangeEnabled &&
    params.canEdit &&
    isActiveBedbankGuestNameChangeBooking(params.item, params.room) &&
    Boolean(params.canChangeGuestName)
}

export function canShowBedbankSpecialRequestsTile(
  item: App.OrderBedbankItem,
  room: App.OrderBedbankRoom,
  canEdit: boolean,
  hotelSupportsSpecialRequest?: boolean,
) {
  const hasUpdatedGuestSpecialRequests = hasBedbankGuestSpecialRequests(room)
  const isBeforeCheckInDate = item.checkIn && moment(item.checkIn).isAfter(moment())
  const supplierAllowsSpecialRequest = isAgodaBedbankItem(item)
    ? hotelSupportsSpecialRequest === true
    : isExpediaBedbankItem(item)

  return supplierAllowsSpecialRequest &&
    (isBeforeCheckInDate || hasUpdatedGuestSpecialRequests) &&
    item.status !== ITEM_STATUS_CANCELLED &&
    room.status !== 'cancelled' &&
    room.status !== 'pending' &&
    canEdit
}
